module.exports = __webpack_public_path__ + "img/preview-13.a600f5bb.png";